import React, { useEffect, useState } from 'react';
import { injectIntl } from 'react-intl';
import { i18nIntl, isNotEmpty, parseClasses } from '../../lib/ep.js';

import FieldErrorMessage from './FieldErrorMessage';
import FieldLabel from './FieldLabel';
import Model from './Model';
import Select from './Select';

const DateWithSelector = (props) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	const [ min_year, setMinYear ] = useState(props?.min_year ?? (EPGetDateYear() - 90));
	const [ max_year, setMaxYear ] = useState(props?.max_year ?? EPGetDateYear());
	const [ errors, setErrors ] = useState(props.errors);

	const model = props?.model ?? {};

	const default_day = ((model[props.name] != null) ? String(EPGetDate(model[props.name])).padStart(2, '0') : '');
	const default_month = ((model[props.name] != null) ? String((new Date(model[props.name])).getMonth() + 1).padStart(2, '0') : '');
	const default_year = ((model[props.name] != null) ? EPGetDateYear(model[props.name]) : '');

	const [ date, setDate ] = useState({ day:default_day, month:default_month, year:default_year });

	useEffect(() => {
		if(props.min_year != min_year) setMinYear(props.min_year);
		if(props.max_year != max_year) setMaxYear(props.max_year);
		if(props.errors != errors) setErrors(props.errors);
	}, [ props ]);

	const change = (k, v) => {
		const _date = { ...date, [k]:v };
		setDate(_date);

		if(_date.day != '' && _date.month != '' && _date.year != '' && props.change != undefined) {
			props.change(props.name,_date);
		}
	};

	const days_arr = [{ k:'', v:`-- ${i18n("day", 'ucfirst')} --` }];
	for(let i = 1; i < 32; i++) days_arr.push({ k:((i < 10) ? `0${i}` : i), v:i });

	const months_arr = [{ k:'', v:`-- ${i18n("month", 'ucfirst')} --` }];
	for(let i = 1; i <= 12; i++) months_arr.push({ k:((i < 10) ? `0${i}` : i), v:EPGetMonthAtPos(i - 1) });

	const years_arr = [{ k:'', v:`-- ${i18n("year", 'ucfirst')} --` }];
	for(let i = max_year; i >= min_year; i--) years_arr.push({ k:i, v:i });

	const _field_styles = props?._field_style ?? {};

	const has_error = (isNotEmpty(errors, props.name)) ? errors[props.name] : false;

	let classname = props?.classname ?? 'input date_selector';
	classname = parseClasses(classname, props._class, 'input');

	const container_classes = ['react_field'];
	if(props._field_class != undefined) container_classes.push(props._field_class);

	return (
		<div class={container_classes.join(" ")} style={_field_styles}>
			<div class={classname + ((has_error) ? ' has_error' : '')}>
				{(props.children) && (
					<FieldLabel
						{...props.label_props}
						name={props.name}
						autotranslate={props.autotranslate}
					>{props.children}</FieldLabel>
				)}

				<div class="field_container this_date">
					<Model
						model={date}
						change={change}
						errors={errors}
						classname="selects_container"
						style={{
							display:'flex',
							gap:'0.5em',
						}}
					>
						<Select
							name="day"
							values={days_arr}
							value={date.day}
							autotranslate={false}
							_class={{ first:true, other:((has_error) ? 'has_error' : '') }}
						/>

						<Select
							name="month"
							values={months_arr}
							value={date.month}
							autotranslate={false}
							_class={{ first:true, other:((has_error) ? 'has_error' : '') }}
						/>

						<Select
							name="year"
							values={years_arr}
							value={date.year}
							autotranslate={false}
							_class={{ first:true, other:((has_error) ? 'has_error' : '') }}
						/>
					</Model>
				</div>
			</div>

			{(has_error) && (
				<FieldErrorMessage
					error_msg_position_class={props.error_msg_position_class}
				>{has_error}</FieldErrorMessage>
			)}

			{(isNotEmpty(props, 'after_message')) && (
				<div class="gui_after_message">
					{props.intl.formatMessage({ id:props.after_message })}
				</div>
			)}
		</div>
	)
};

export default injectIntl(DateWithSelector);